export const config = {
	ThunderstormModule: {
		appName: 'IR Support Portal - STG'
	},
	XhrHttpModule: {
		origin: "",
		timeout: 30000,
		compress: false
	},
	// gen-2 apiv2 (Cloud Run) direct URL — TTS SSE stream only, to bypass
	// Firebase Hosting's response buffering. See config-dev.ts.
	ttsStreamOrigin: "https://us-central1-ir-q-support-staging.cloudfunctions.net/apiv2",
	"labTestUrl": "https://ir-q-support-staging-new.firebaseapp.com/name-input",
	"suggestTranslationEnabled": false,
	ActivationModule: {
		userOnlyEnabled: true
	},
	UnitsModule: {
		dbName: "elliq-env-dev"
	},
	EnvironmentModule: {
		envName: "staging",
		kasperoFeUrl: "https://elliq-env-map-staging.firebaseapp.com",
        kasperoBeUrl: "https://us-central1-elliq-env-map-staging.cloudfunctions.net/apiv2",
		apiServerUrl: "https://elliq-api-server-staging.s.elliq.co:443/api/"
	},
	PackageManagerModule: {
		pmOrigin: "/pm-api"
	},
	ContactsModule: {
		websiteUrl: "https://ir-q-messaging-staging.firebaseapp.com",
		defaultAreaCode: "+1"
	},
	PushPubSubModule: {
		publicKeyBase64: 'BD50qkEfWV-7NWvCAOAWpqDrY9kqnqmLE9KcDHd-uyTGwN30-fqeWcwwsk-bbsU_E-CtiQup945eZl2jxfmwm1I',
		swFileName: 'sw.js'
	},
	CareCenterModule: {
		websiteUrl: "https://ir-q-care-center-staging.firebaseapp.com",
		commandsUrl: "https://ir-commands-staging.web.app"
	},
	KasperModule: {
		origin: "https://us-central1-elliq-env-map-staging.cloudfunctions.net/apiv2"
	},
	FirebaseModule: {
		local: {
			apiKey: "AIzaSyCsAdd5depLP_xTODrD8bqYdARR91pn2QY",
			authDomain: "ir-q-support-staging.firebaseapp.com",
			databaseURL: "https://ir-q-support-staging.firebaseio.com",
			projectId: "ir-q-support-staging",
			messagingSenderId: "699594957134",
			appId: "1:699594957134:web:9633b0ccb89fd2b995fe1f"
		},
		pushResult: {
			id: "elliq-env-map-staging",
			apiKey: "AIzaSyDcIgMXN1qnzI1xn5M9o8OgSe4rfOtEPr4",
			authDomain: "elliq-env-map-staging.firebaseapp.com",
			databaseURL: "https://elliq-env-map-staging.firebaseio.com",
			projectId: "elliq-env-map-staging",
			storageBucket: "elliq-env-map-staging.appspot.com",
			messagingSenderId: "759164498621",
			appId: "1:759164498621:web:801b7083e6468056203dd4"
		},
		ks: {
			apiKey: "AIzaSyDZHdnc1mUdQTA4FjKrvmlszHfBy0JK6hk",
			authDomain: "elliq-env-map.firebaseapp.com",
			databaseURL: "https://elliq-env-map.firebaseio.com",
			projectId: "elliq-env-map",
			storageBucket: "elliq-env-map.appspot.com",
			messagingSenderId: "1067544170250",
			appId: "1:1067544170250:web:2acdc4358c16ee9b4034f3"
		},
		sd: {
			apiKey: "AIzaSyA7YqQxjZO8M_ayGUwkY3YrJPH4gU9jg5w",
			authDomain: "ir-q-state-dashboard-staging.firebaseapp.com",
			databaseURL: "https://ir-q-state-dashboard-staging-773a7.firebaseio.com",
			projectId: "ir-q-state-dashboard-staging",
			storageBucket: "ir-q-state-dashboard-staging.appspot.com",
			messagingSenderId: "868100673306",
			appId: "1:868100673306:web:0a82b76ed1eed42bcde6a3"
		}
	},
	installBlockerConditions: [
		{
			currentVersionLowerThan: "3.4.6",
			packageVersionIsEqualOrBiggerThan: "3.4.6",
			mustInstallFirst: "3.4.6"
		}
	],
	BigQueryModule: {
		dataSet: "ir-datastore-test"
	}
};
